export default "__VITE_ASSET__d8bd91fe__"